module.exports = __webpack_public_path__ + "static/media/playstore.6bd86f7f.png";